import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/Auth";
import Layout from "../../pages/Layout";

export const PrivateRoute = () => {
  const { user } = useAuth();
  return user ? <Layout /> : <Navigate to="/" replace />;
};
